export default {
    customize:[
        {
            sequence:'1',
            tit:'中成药用药临床证据评价',
            info:{
                abstract: {
                    tit:'摘要',
                    list:[
                         '基于文献材料，提供中成药的文献检索、分类与分析服务，对中成药用药临床证据进行评价。',
                    ]
                },
                example:{
                    tit:'样例报告',
                    list:[
                        {
                            pdfTit:'1.《四磨汤文献检索与分析报告》.pdf',
                            href:'./attachment-pdf/01 《四磨汤文献检索与分析报告》.pdf',
                        },
                        {
                            pdfTit:'2.《养胃颗粒/冲剂预检索报告》.pdf',
                            href:'./attachment-pdf/02 《养胃颗粒or冲剂预检索报告》.pdf',
                        },
                        {
                            pdfTit:'3.《厚朴排气合剂文献预检索报告》.pdf',
                            href:'./attachment-pdf/03 《厚朴排气合剂文献预检索报告》.pdf',
                        },
                        {
                            pdfTit:'4.《丹红注射液临床文献分析报告》.pdf',
                            href:'./attachment-pdf/04 《丹红注射液临床文献分析报告》.pdf',
                        },
                        {
                            pdfTit:'5.《注射用丹参多酚酸盐临床文献分析报告》.pdf',
                            href:'./attachment-pdf/05 《注射用丹参多酚酸盐临床文献分析报告》.pdf',
                        },
                        {
                            pdfTit:'6.《四季抗病毒合计临床应用专家共识-检索报告》.pdf',
                            href:'./attachment-pdf/06-1 《四季抗病毒合计临床应用专家共识-检索报告》.pdf',
                        },
                        {
                            pdfTit:`&nbsp;&nbsp;&nbsp;《四季抗病毒合剂临床应用专家共识-证据评价报告及证据概要表》.pdf`,
                            href:'./attachment-pdf/06-2 《四季抗病毒合剂临床应用专家共识-证据评价报告及证据概要表》.pdf',
                        },
                        {
                            pdfTit:'&nbsp;&nbsp;&nbsp;《四季抗病毒合计临床应用专家共识-证据综合报告》.pdf',
                            href:'./attachment-pdf/06-3 《四季抗病毒合剂临床应用专家共识-证据综合报告》.pdf',
                        },
                        {
                            pdfTit:'7.《复方沙棘籽油栓临床应用专家共识-检索报告》.pdf',
                            href:'./attachment-pdf/07-1 《复方沙棘籽油栓临床应用专家共识-检索报告》.pdf',
                        },
                        {
                            pdfTit:'&nbsp;&nbsp;&nbsp;《复方沙棘籽油栓临床应用专家共识-证据评价报告及证据概要表》.pdf',
                            href:'./attachment-pdf/07-2 《复方沙棘籽油栓临床应用专家共识-证据评价报告及证据概要表》.pdf',
                        },
                        {
                            pdfTit:'&nbsp;&nbsp;&nbsp;《复方沙棘籽油栓临床应用专家共识-证据综合报告》.pdf',
                            href:'./attachment-pdf/07-3 《复方沙棘籽油栓临床应用专家共识-证据综合报告》.pdf',
                        },
                    ]
                } ,
                achievement:{
                    tit:'课题组成果',
                    list:[
                        {
                            pdfTit:'1.《四磨汤口服液用于慢性胃肠疾病治疗及腹部手术后肠胃功能康复的专家共识》.pdf',
                            href:'./attachment-pdf/《四磨汤口服液用于慢性胃肠疾病治疗及腹部手术后肠胃功能康复的专家共识》.pdf',
                            txt:'简介：本共识由中国中医科学院西苑医院脾胃病研究所、湖南汉森制药股份有限公司提出，由中华中医药学会归口（GS/CACM 285-2020）。共识通过对四磨汤口服液（中成药）现有文献的梳理和分析，以专家共识为主，对四磨汤口服液在临床中的应用与安全性进行了系统说明。本共识分为总论部分、内科部分、外科部分及安全性四大部分，共25条。本平台服务团队承担了共识的文献检索与分析报告，为共识的研制提供了参考。'
                        },
                        {
                            pdfTit:'2. 《养胃颗粒治疗慢性萎缩性胃炎临床应用专家共识》.pdf',
                            href:'./attachment-pdf/《养胃颗粒治疗慢性萎缩性胃炎临床应用专家共识》.png',
                            txt:'简介：本共识由中国中医科学院西苑医院脾胃病研究所、正大青春宝药业有限公司提出，由中华中医药学会归口（GS/CACM 315-2023），起草单位为中国中医科学院西苑医院脾胃病研究所。共识工作组通过梳理药品说明书、文献检索与证据评价、专家访谈、市场应用调研、专家德尔菲法调查、专家研讨会等，形成了涉及九个方面的三十一条推荐意见/建议。本共识旨在提高临床医生对养胃颗粒适应病、证、症状等方面的认识，促进临床合理精准用药、提高疗效、保障用药安全等。本平台服务团队承担了共识的文献预检索与分析服务，为共识的研制提供了参考。'
                        }
                    ]
                }, 
            }
        },
        {
            sequence:'2',
            tit:'中医消化疾病循证大数据平台',
            info:{
                abstract: {
                    tit:'摘要',
                    list:[
                         '中医消化疾病循证大数据平台，是在中国中医药循证医学中心消化疾病协同创新联盟领导下，由中国中医科学院西苑医院脾胃病研究所和中国中医科学院中医药信息研究所大健康智能研发中心牵头，整合包括13个全国脾胃病区域诊疗中心、34家国家临床研究基地脾胃病科的科研力量，在消化领域优势病种循证文献大数据平台（I期）的基础上协同进行消化疾病循证大数据建设的工作平台。',
                         '平台的数据来源为消化领域优势病种基础数据库，基础数据库储存了大量经过人工审核的结构化文本和pdf原文，文献类型包括临床试验类文献、系统评价、证候流行病学研究类文献、临床路径、指南与共识、名医经验和个案报道。平台提供检索、专病证据库、证据图、知识图谱、在线meta分析、医案数据挖掘、证据概览表、证据链等功能。',
                    ],
                    imgList:[
                        {
                            pic:require('../../assets/images/customize-info/xh-pic1.png'),
                            width:'604px'
                        },
                        {
                            pic:require('../../assets/images/customize-info/xh-pic2.png'),
                            width:'604px'
                        },
                        
                    ]
                },
                platform:{
                    tit:'平台链接',
                    href:'https://ai.tcmcds.com/pw2/login',
                } ,
                 
            }
        },
        {
            sequence:'3',
            tit:'中医诊疗体系重构知识分析平台',
            info:{
                abstract: {
                    tit:'摘要',
                    list:[
                         '中医学三大传统医学思想包括整体观、个体化和治未病，但作为传统的中医诊疗体系，存在着刻强轴弱、态强靶弱、个强群弱三种不足。为此，仝小林院士提出了重构中医诊疗体系的思想，即重新对中医进行分类分期分症，并将“态靶医学” 作为未来中医诊疗体系的重要方向。为此，我们开展了“中医诊疗体系重构相关文献整理”项目，旨在通过文献检索、文献计量学分析和知识图谱等技术，全面整理当前中医诊疗体系的现状，预判未来的学科发展规律。本项目围绕中医诊疗体系这一主题，开展了文献检索、数据库构建、知识图谱构建，知识分析，通过这一网站提供相关资源与服务。',
                    ],
                    imgList:[
                        {
                            pic:require('../../assets/images/customize-info/xzfw.png'),
                            width:'100%'
                        },
                        {
                            pic:require('../../assets/images/customize-info/xzgpcy.png'),
                            width:'100%'
                        },
                        {
                            pic:require('../../assets/images/customize-info/zstp.png'),
                            width:'800px'
                        },
                        
                    ]
                },
                platform:{
                    tit:'平台链接',
                    href:'https://www.tcmkb.cn/tcmkb/pages/clinic_systems.jsp',
                } ,
                 
            }
        },
        {
            sequence:'4',
            tit:'《黄帝内经》理论研究工作平台',
            info:{
                abstract: {
                    tit:'摘要',
                    list:[
                         '《黄帝内经》分《灵枢》、《素问》两部分，是中国最早的医学典籍，传统医学四大经典著作之一。',
                         '《黄帝内经》是一本综合性的医书，在黄老道家理论上建立了中医学上的“阴阳五行学说”、“脉象学说”、“藏象学说”、“经络学说”、“病因学说”、“病机学说”、“病症”、“诊法”、“论治”及“养生学”、“运气学”等学说，从整体观上来论述医学，呈现了自然、生物、心理、社会“整体医学模式”。 其基本素材来源于中国古人对生命现象的长期观察、大量的临床实践以及简单的解剖学知识。《黄帝内经》奠定了人体生理、病理、诊断以及治疗的认识基础，是中国影响极大的一部医学著作，被称为医之始祖。',
                         '《黄帝内经》理论研究工作平台整合了《黄帝内经》的相关古籍图书、现代图书、研究论文以及集注知识，并且在不断更新中，用户通过该平台可以快速、全面了解到《黄帝内经》的相关知识。'
                    ],
                    imgList:[
                        {
                            pic:require('../../assets/images/customize-info/hdnj-pic1.png'),
                            width:'100%'
                        },
                        {
                            pic:require('../../assets/images/customize-info/hdnj-pic2.png'),
                            width:'100%'
                        },
                        {
                            pic:require('../../assets/images/customize-info/hdnj-pic3.png'),
                            width:'100%'
                        },
                        
                    ]
                },
                platform:{
                    tit:'平台链接',
                    href:'',
                } ,
                 
            }
        },
        {
            sequence:'5',
            tit:'糖尿病足临床研究平台',
            info:{
                abstract: {
                    tit:'摘要',
                    list:[
                         '坚持以临床价值为导向，构建中医药理论、“人用经验”和临床试验“三结合”的中药审评证据体系，推动建立与中药临床定位相适应、体现其作用特点和优势的疗效评价标准，用“现代语”诠释中医药，正在成为新时期中医药迈向高质量发展的重要创新路径。',
                         '基于此，委托机构委托我们针对多发病常见病糖尿病足构建了古今文献的检索平台，并进一步在此基础上，基于知识图谱和深度学习等现代信息技术自动抽取构建2期构建糖尿病足临床研究的集成平台。平台基于古籍、临床指南、名医经验，进行系统梳理，提取病因病机、临床表现，诊断要点、鉴别诊断、治则治法、特色疗法、预后转归、难点与对策，构建糖尿病足中医诊疗理论知识库； 疾病、证候、治则治法、方剂、中药、针灸、按摩、其他疗法等，构建糖尿病足历代医案知识库构建；同时提取中西医临床研究类型、疗效观察指标、疾病特点、干预方式等，构建糖尿病足中西医临床研究知识库，最后实现了平台临床研究数据的共享服务。'
                    ],
                    imgList:[
                        {
                            pic:require('../../assets/images/customize-info/tnbz.png'),
                            width:'1000px'
                        }, 
                        
                    ]
                },
                platform:{
                    tit:'平台链接',
                    href:'https://ai.tcmcds.com/tnbz/',
                } ,
                 
            }
        },
    ]
}